import { render } from "./MarketingPreferencesAttributesTable.vue?vue&type=template&id=62485e3e&scoped=true"
import script from "./MarketingPreferencesAttributesTable.vue?vue&type=script&lang=js"
export * from "./MarketingPreferencesAttributesTable.vue?vue&type=script&lang=js"

import "./MarketingPreferencesAttributesTable.vue?vue&type=style&index=0&id=62485e3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62485e3e"]])

export default __exports__